import { Box, styled, Typography } from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { EPOCUS_WHITE, rem } from "../epocus-palette";
import type { CineMetadata } from "./cine-metadata";

const Badge = styled(Box)({
  position: "absolute",
  top: 3,
  right: 3,
  display: "flex",
  alignItems: "center",
  gap: 1,
  padding: "1px 4px 1px 2px",
  borderRadius: 8,
  pointerEvents: "none",
});

const FrameCount = styled(Typography)({
  fontSize: rem(9),
  lineHeight: 1.2,
  color: EPOCUS_WHITE,
  fontVariantNumeric: "tabular-nums",
});

export const CineThumbnailBadge: FC<{ metadata: CineMetadata }> = ({
  metadata,
}) => (
  <Badge
    style={{
      backgroundColor:
        metadata.availability === "READY"
          ? "rgba(0,0,0,0.65)"
          : "rgba(107,114,128,0.85)",
    }}
  >
    <PlayArrowIcon style={{ fontSize: 12, color: EPOCUS_WHITE }} />
    <FrameCount>{metadata.numberOfFrames}</FrameCount>
  </Badge>
);
